import { DomainId } from './domain_id';
/**
 * These are helper classes that simplify DomainId generator for well known types.
 */
export class ApiCredentialId extends DomainId {
    constructor(sid) {
        super('api', sid);
    }
}
export class AppId extends DomainId {
    constructor(sid) {
        super('app', sid);
    }
}
export class CapabilitiesId extends DomainId {
    constructor(sid) {
        super('consum', sid);
    }
}
export class CompanyId extends DomainId {
    constructor(sid) {
        super('co', sid);
    }
}
export class DeviceId extends DomainId {
    constructor(sid) {
        super('dvc', sid);
    }
}
export class EntityEventId extends DomainId {
    constructor(sid) {
        super('event', sid);
    }
}
export class GroupId extends DomainId {
    constructor(sid) {
        super('grp', sid);
    }
}
export class GPSRequestId extends DomainId {
    constructor(sid) {
        super('gpr', sid);
    }
}
export class InvitationId extends DomainId {
    constructor(sid) {
        super('uinv', sid);
    }
}
export class RoomId extends DomainId {
    constructor(sid) {
        super('rm', sid);
    }
}
export class RoomInvitationId extends DomainId {
    constructor(sid) {
        super('inv', sid);
    }
}
export class AnonymousUserId extends DomainId {
    constructor(sid) {
        super('anon', sid);
    }
}
export class LoginIdentityId extends DomainId {
    constructor(sid) {
        super('lid', sid);
    }
}
export class StreemshotId extends DomainId {
    constructor(sid) {
        super('ss', sid);
    }
}
export class StreemshotRevisionId extends DomainId {
    constructor(sid) {
        super('ssrev', sid);
    }
}
export class StreemshotRequestId extends DomainId {
    constructor(sid) {
        super('ssr', sid);
    }
}
export class RecordingId extends DomainId {
    constructor(sid) {
        super('rec', sid);
    }
}
export class RecordingTrackId extends DomainId {
    constructor(sid) {
        super('tr', sid);
    }
}
export class GpsId extends DomainId {
    constructor(sid) {
        super('gps', sid);
    }
}
export class BookmarkId extends DomainId {
    constructor(sid) {
        super('bm', sid);
    }
}
export class RoomOutcomeReportId extends DomainId {
    constructor(sid) {
        super('ror', sid);
    }
}
export class MeshId extends DomainId {
    constructor(sid) {
        super('mesh', sid);
    }
}
export class NoteId extends DomainId {
    constructor(sid) {
        super('nt', sid);
    }
}
export class DetectionId extends DomainId {
    constructor(sid) {
        super('det', sid);
    }
}
export class FeedbackId extends DomainId {
    constructor(sid) {
        super('feed', sid);
    }
}
export class UserId extends DomainId {
    constructor(sid) {
        super('usr', sid);
    }
}
export class CognitoUserId extends DomainId {
    constructor(sid) {
        super('cusr', sid);
    }
}
export class SessionId extends DomainId {
    constructor(sid) {
        super('sesh', sid);
    }
}
/* AR Elements */
export class ElementGroupId extends DomainId {
    constructor(sid) {
        super('elg', sid);
    }
}
export class AnchorId extends DomainId {
    constructor(sid) {
        super('anc', sid);
    }
}
export class ElementId extends DomainId {
    constructor(sid) {
        super('ele', sid);
    }
}
export class PresentationId extends DomainId {
    constructor(sid) {
        super('pres', sid);
    }
}
export class ScanningRequestId extends DomainId {
    constructor(sid) {
        super('arsr', sid);
    }
}
export class AnchorRequestId extends DomainId {
    constructor(sid) {
        super('arar', sid);
    }
}
export class CatalogItemId extends DomainId {
    constructor(sid) {
        super('cat', sid);
    }
}
export class CameraSubjectRequestId extends DomainId {
    constructor(sid) {
        super('cam', sid);
    }
}
export class CameraSubjectResponseId extends DomainId {
    constructor(sid) {
        super('csrr', sid);
    }
}
export class GroupReservationId extends DomainId {
    constructor(sid) {
        super('rsv', sid);
    }
}
//# sourceMappingURL=domain_id.well-known.js.map